import React, { ChangeEvent } from "react";
import { useBranchForm } from "../hooks/useBranchForm";
import { ModalWrapper } from "../../../../components/ModalWrapper";
import BranchForm from "../components/BranchForm";
import EditBranchActions from "./EditBranchActions";
import LoadingScreen from "../../../../components/LoadingScreen";
import { useEditBranch } from "../hooks/useEditBranch";

interface Props {
  id: string;
  closeEdit: () => void;
  fetchBranches: () => void;
}

const EditBranch: React.FC<Props> = ({ id, closeEdit, fetchBranches }) => {
  const { formData, doberror, error, refs, updateFormData, handleDobChange, handlePincodeChange, createKeyPressHandler, handleBranchnamesKeyPress } = useBranchForm();

const {
  loading,
  visible,
  updateBranch,
  setDateDirty,
} = useEditBranch(
  id,
  formData,
  updateFormData, // ✅ REQUIRED
  doberror,
  error,
  closeEdit,
  fetchBranches
);


  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") updateBranch();
  };

  const handleDobChangeWithDirty = (e: ChangeEvent<HTMLInputElement>) => {
    handleDobChange(e);
    setDateDirty(true);
  };

  return (
    <div>
      <ModalWrapper title="Edit Branch" onClose={closeEdit} width="max-w-xl">
        <BranchForm
          formData={formData}
          doberror={doberror}
          error={error}
          refs={refs}
          onFormChange={updateFormData}
          onDobChange={handleDobChangeWithDirty}
          onPincodeChange={handlePincodeChange}
          onBranchnameKeyPress={handleBranchnamesKeyPress}
          createKeyPressHandler={createKeyPressHandler}
          onKeyPress={handleKeyPress}
          isEdit={true}
          disabledFields={["name"]}
        />

        <EditBranchActions onCancel={closeEdit} onUpdate={updateBranch} visible={visible} loading={loading} />
      </ModalWrapper>


      {loading && <LoadingScreen />}
    </div>
  );
};

export default EditBranch;
